module.exports = __webpack_public_path__ + "static/media/-_Employee Core Data.5245ab14.png";